import { FC, RefObject } from 'react';
import { SearchOutlined }        from '@ant-design/icons';
import { Button, Input, InputRef, Space } from 'antd';
import { FilterDropdownProps }            from 'antd/es/table/interface';

type TProps = FilterDropdownProps & {
  dataIndex: string,
  onSearch: ({ searchText, searchColumn }: { searchText: string, searchColumn: string }) => void,
  searchInput: RefObject<InputRef>,
}

export const TableFilter: FC<TProps> = ({ dataIndex, setSelectedKeys, selectedKeys, confirm, searchInput, clearFilters, close, onSearch }) => {

  const handleSearch = () => {
    confirm();
    onSearch({ searchText: selectedKeys[0] as string, searchColumn: dataIndex });
  };

  const handleReset = () => {
    clearFilters && clearFilters();
    confirm();
    onSearch({ searchText: '', searchColumn: dataIndex });
  };

  return (
    <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <Input
        ref={searchInput}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [ e.target.value ] : [])}
        onPressEnter={handleSearch}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <Space>
        <Button
          type="primary"
          onClick={handleSearch}
          icon={<SearchOutlined/>}
          size="small"
          style={{ width: 90 }}
        >
          Search
        </Button>
        <Button
          onClick={handleReset}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
        <Button
          type="link"
          size="small"
          onClick={() => {
            confirm({ closeDropdown: false });
            onSearch({ searchText: selectedKeys[0] as string, searchColumn: dataIndex });
          }}
        >
          Filter
        </Button>
        <Button
          type="link"
          size="small"
          onClick={() => {
            close();
          }}
        >
          close
        </Button>
      </Space>
    </div>
  );
};
